// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__25guC","loaderOuter":"PageOverlayLoader_loaderOuter__3bBnx"};